// src/components/UI/components/DropdownMenu/DropdownMenuSeparator.tsx

import { Separator } from '@radix-ui/react-dropdown-menu';
import { forwardRef } from 'react';
import { cx } from '../../lib/utils';

const DropdownMenuSeparator = forwardRef<
  React.ElementRef<typeof Separator>,
  React.ComponentPropsWithoutRef<typeof Separator>
>(({ className, ...props }, forwardedRef) => (
  <Separator
    ref={forwardedRef}
    className={cx(
      '-mx-1 my-1 h-px border-t border-gray-200 dark:border-gray-800',
      className,
    )}
    {...props}
  />
));
DropdownMenuSeparator.displayName = 'DropdownMenuSeparator';

export { DropdownMenuSeparator };
